import React from "react";

import type { TAuthenticationMethod } from "@mne-authentication/api";

import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { FormattedMessage } from "@mnemonic/intl";
import * as ArgusUtils from "@mnemonic/pure-utils";

import { commonMessages } from "../../commonMessages";
import { redirectToValidatedNextURI } from "../../utils/nextURIRedirect";

export const UnsupportedMethod = ({ method, nextURI }: { method: TAuthenticationMethod; nextURI: string }) => {
  const isEnrollment = method === "ENROLLMENT";
  const bodyMessage = isEnrollment
    ? commonMessages.UnsupportedAuthorizationMethod_enrollment
    : commonMessages.UnsupportedAuthorizationMethod_generic;
  const retryMessage = isEnrollment
    ? commonMessages.UnsupportedAuthorizationMethod_tryAgain
    : commonMessages.UnsupportedAuthorizationMethod_tryAgain_generic;

  return (
    <Stack spacing={2}>
      <Typography>
        <FormattedMessage
          {...bodyMessage}
          values={{
            method: method,
            b: (chunks: React.ReactNode[]) => <strong>{chunks}</strong>,
          }}
        />
      </Typography>

      <Typography>
        <FormattedMessage {...retryMessage} />
      </Typography>
      <Stack direction="row" sx={{ justifyContent: "space-evenly", mt: 2 }}>
        <Button
          variant="outlined"
          onClick={() => void redirectToValidatedNextURI(nextURI)}
          sx={{ width: 1 / 3 }}
        >
          <FormattedMessage {...commonMessages.Cancel} />
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            window.location.href = ArgusUtils.toSpaUrl(`authentication/logout`);
          }}
          sx={{ width: 1 / 3 }}
        >
          <FormattedMessage {...commonMessages.LogOut} />
        </Button>
      </Stack>
    </Stack>
  );
};
